export const getOrdinal = (number, delimiter = '-') => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const numberMod = number % 100;
  return `${number}${delimiter}${(suffixes[(numberMod-20) % 10] || suffixes[numberMod] || suffixes[0])}`;
};



// WEBPACK FOOTER //
// ./src/utilities/numbers.js